module.exports = __webpack_public_path__ + "img/appIcon.790d855e.png";